import styled from 'styled-components';
import { motion } from 'framer-motion';

export const Container = styled(motion.div).attrs(({ $isOpened }) => ({
  animate: { width: $isOpened ? '100%' : 0, height: $isOpened ? '100%' : 0, opacity: $isOpened ? 1 : 0 },
  transition: { duration: 0.3 },
  initial: false,
}))`
  display: flex;
  flex-direction: column;
  max-width: 600px;
  height: 100%;
  position: fixed;
  inset: 0 0 0 auto;
  background-color: var(--color-white);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border-left: 1px solid var(--color-grey-e9);
  overflow: hidden;
  z-index: 100;
`;

export const Navbar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 64px;
  padding: 0 24px;
  border-bottom: 1px solid var(--color-grey-e5);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  flex-shrink: 0;
  background-color: var(--color-white);
`;

export const NavLogo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const NavLogoIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background-color: var(--color-primary);
  border-radius: 12px;
  flex-shrink: 0;
`;

export const NavTitle = styled.span`
  font-size: 16px;
  font-weight: 600;
  color: var(--color-grey-1d);
  white-space: nowrap;
`;

export const NavBadge = styled.span`
  font-size: 12px;
  font-weight: 500;
  color: #171717;
  background-color: var(--color-grey-f4);
  border-radius: 8px;
  padding: 1px 5px;
`;

export const NavActions = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const NavActionButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background: none;
  border-radius: 8px;
  cursor: pointer;
  opacity: 0.7;
  & > svg {
    width: 16px;
    height: 16px;
  }
  @media (hover) {
    &:hover {
      background-color: var(--color-grey-f4);
      opacity: 1;
    }
  }
`;
